import all from './all';
import createCoa from './createCoa';
import store from './store';
import update from './update';
import destroy from './destroy';

export default {
  all,
  createCoa,
  store,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/index.js